module.exports = __webpack_public_path__ + "img/8market3-u.65562161.jpg";